<script setup lang="ts">
// Import
import type { AdminApiGetArea } from '~/app-modules/admin/types';
import ManageArea from '../../../components/modal/manageArea.vue';

// Composables
const { getSite } = useSiteApi();

// Store
const { currentSite } = storeToRefs(adminStore());

// Data
const isAreaModalOpen = ref(false);
const parentId = ref(0);
const manageAreaData = ref<AdminApiGetArea | null>(null);

// Computed
const siteId = computed(() => currentSite.value?.id);
const areas = computed(() => currentSite.value?.areas ?? []);

// Methods
const openAreaModal = (id: number) => {
  parentId.value = id;
  isAreaModalOpen.value = true;
};

const openManageAreaModal = (id: number) => {
  manageAreaData.value = currentSite.value?.areas.find((area) => area.id === id) ?? null;
  isAreaModalOpen.value = true;
};

const updateAreas = () => {
  if (siteId.value) {
    getSite(siteId.value);
  }
};
</script>
<template>
  <ui-card>
    <ui-chart-flow :areas="areas" show-add-node-button @click-on-area="openManageAreaModal" @add-child="openAreaModal" />

    <!-- Modal -->
    <manage-area
      v-if="siteId"
      v-model="isAreaModalOpen"
      :site-id="siteId"
      :parent-id="parentId"
      :area="manageAreaData ?? undefined"
      @update-areas="updateAreas"
    />
  </ui-card>
</template>
